// import Attractions from '../../../../../stories/components/hotels/DetailsPage/Attractions/Attractions'
import {updateCurrentRoom} from '@stencil/hotels-details-reducer/src/actions';
import {
  freeBreakfastOrCancellationPersuasionAndAdditionalPersuasionSelector,
  hotelsAmenitiesSelector,
  hotelStaticMinPrice as hotelStaticMinPriceSelectorFn,
  isStaticDataLoading as isStaticDataLoadingSelectorFn,
  locationPersuasionsSelector,
  roomsDataHermes as roomsDataHermesSelectorFn,
  ugcSentiments as ugcSentimentsSelectorFn,
} from '@stencil/hotels-details-reducer/src/selectors';
// TYPES
import {HQueryType, RoomDataType} from '@stencil/hotels-details-reducer/src/types';
// UTILS
import calculateRoomPriceData from '@stencil/hotels-utils/src/details-calculate-room-price-data';
import detailsPageClickGaPush from '@stencil/hotels-utils/src/details-page-click-ga-push';
import {IUserStoreState, userSelector} from '@stencil/user-reducer';
// THEME
import buildMisc from 'build-theme/src/build-misc';
import buildSpacing from 'build-theme/src/build-spacing';
import React, {useCallback, useEffect, useState} from 'react';
// HOOKS
import {useDispatch, useSelector} from 'react-redux';
import {createSelector} from 'reselect';
import WhatOurGuestLikeLoader from '../../../../../stories/components/hotels/Loadingpage/WhatOurGuestLikeLoader/WhatOurGuestLikeLoader';
import PersuasionHoverText from '../../../../../stories/components/hotels/SRP/PersuasionHoverText/PersuasionHoverText';
import ClientOnly from '@stencil/generic-client-only-component';
// import UserReviewLeftComponent from 'verticals/hotels-dweb/src/stories/components/hotels/Loadingpage/RnR/UserReviewRightComponent/UserReviewRightComponent';
import {DetailsGAClickEventActions, LoggedInPriceBenefitLabel} from '../../../../config/ga-config';
import useCurrentRoomData from '../../../../hooks/useCurrentRoomData';
import useQuery from '../../../../hooks/useQuery';
// REDUX ACTIONS
import {OuterWrapperDiv} from '../Breadcrumb/Breadcrumb.styles';
// import EMIPersuasion from './EMIPersuasion'; // 🐨 can be lazy loaded depending on the data
import BookingWidget from './BookingWidget';
// COMPONENTS
import GalleriesAndLocationPersuasion from './GalleriesAndLocationPersuasion';
// import {updateUgcImages} from '../../redux/actions';
// import {AppState} from '../../../../store';
import LoginPersuasionWithoutPrice from './LoginPersuasionWithoutPrice';
import SignUpPersuasion from './SignUpPersuasion';
import * as S from './styles/PriceNBookingButtonNPersuasion.styles';
import UGCCardChips from './UGCCardChips';

const bookingWidgetSelector = createSelector(
  [hotelStaticMinPriceSelectorFn, roomsDataHermesSelectorFn],
  (staticMinPrice: number | undefined, roomsDataFromHermes: RoomDataType[] | undefined) => ({
    staticMinPrice,
    roomsDataFromHermes,
  }),
);

import {
  taTagDataSelector,
  giTagDataSelector,
  pendingReviewDataSelector,
} from '@stencil/hotels-ugc-redux/src/hotels-ugc-selectors';

function PriceNBookingButtonNPersuasion() {
  const userDetails = useSelector(userSelector) as IUserStoreState;

  const isLoggedIn = !!userDetails?.isLoggedIn;

  const toggleSiginPopupCaller = useCallback(() => {
    if (window && document) {
      document.querySelector('#get_sign_in').click();
    }
    // dispatch(toggleLoginPopup(true));
  }, []);

  const taTagData = useSelector(taTagDataSelector);
  const giTagData = useSelector(giTagDataSelector);
  const tagDataRequestPending = useSelector(pendingReviewDataSelector);

  const isStaticDataLoading = useSelector(isStaticDataLoadingSelectorFn);

  const hotelAmenitiesData = useSelector(hotelsAmenitiesSelector) || [];
  const {all, cmapped} = hotelAmenitiesData;
  const [amenitiesChipsData, updateAmenitiesChipsData] = useState([]);
  const locationPersuasions = useSelector(locationPersuasionsSelector);
  const {breakFastOrCancellation, additionalPersuasion, dummyPersuasions} = useSelector(
    freeBreakfastOrCancellationPersuasionAndAdditionalPersuasionSelector,
  );

  const dispatch = useDispatch();

  const {roomsDataFromHermes = []} = useSelector(bookingWidgetSelector);

  const {getQueryParam} = useQuery();
  const hQuery = JSON.parse(getQueryParam('hquery') as string) as HQueryType;

  const memoisedCalculateRoomPriceData = useCallback(calculateRoomPriceData, [
    hQuery,
    roomsDataFromHermes,
  ]);

  const currentRoomData = memoisedCalculateRoomPriceData({
    hQuery,
    roomsDataFromHermes,
  });

  // fires on first mount and anytime another room is selected
  useEffect(() => {
    dispatch(updateCurrentRoom(currentRoomData));
  }, [currentRoomData.roomPrice]);

  // updating ugc_images in static data with fresh ugc data
  // useEffect(() => {
  //   dispatch(updateUgcImages(moreUgcImages));
  // }, [moreUgcImages])

  useEffect(() => {
    let amenitiesData = [];
    if (cmapped && cmapped.length) {
      cmapped.map(item => {
        amenitiesData.push(item.n);
      });
      updateAmenitiesChipsData(amenitiesData);
    } else if (all && all.length) {
      updateAmenitiesChipsData(all);
    }
  }, [hotelAmenitiesData]);

  const ugcChipsData = taTagData.length ? taTagData : giTagData;
  const whatOurGuestLike = ugcChipsData.filter(data => !data.title.includes('dislike')) || [];
  const whatOurGuestDislike = ugcChipsData.filter(data => data.title.includes('dislike')) || [];

  const {emiData, roomPriceAfterLogin, roomPrice} = useCurrentRoomData();
  const emiStartingPrice = (emiData && emiData.emi) || '';
  const emiRates = (emiData && emiData.emiRates) || {};

  /**
   * the loader is already taken care of in 'HotelDetails' component
   * (it's a clubbed loader, so using it only at one place)
   */
  if (isStaticDataLoading) return null;
  const showSignUpPersuasion =
    !isLoggedIn && !!roomPriceAfterLogin && !!roomPrice && roomPrice > roomPriceAfterLogin;
  return (
    <OuterWrapperDiv>
      <S.Container>
        <GalleriesAndLocationPersuasion locationPersuasions={locationPersuasions} />
        <S.UGCPersuasionsAndBookingWidget>
          {tagDataRequestPending ? (
            <WhatOurGuestLikeLoader />
          ) : (
            <UGCCardChips
              whatGuestsLikeChips={whatOurGuestLike}
              whatYouShouldKnowChips={whatOurGuestDislike}
              amenitiesData={amenitiesChipsData}
            />
          )}

          <S.SignUpPersuasionEMIBookingWidgetContainer>
            {/* {!showSignUpPersuasion && !!dummyPersuasions.length && isLoggedIn && (
              <StaticDealsContainer>
                {dummyPersuasions.map(p => (
                  <SplDealsPersuasionText key={p} color={p.ccd?.tc} background={p.ccd?.bgc}>
                    {p.pt}
                  </SplDealsPersuasionText>
                ))}
              </StaticDealsContainer>
            )} */}

            {(!!breakFastOrCancellation.length || !!additionalPersuasion.length) && (
              <S.FBOFCADContainer>
                {breakFastOrCancellation.map(p => (
                  <S.FBOFCADText key={p.pt}>
                    <PersuasionHoverText data={breakFastOrCancellation} />
                  </S.FBOFCADText>
                ))}

                {additionalPersuasion && additionalPersuasion.length > 0 && (
                  <S.FBOFCADDealText>
                    <PersuasionHoverText
                      // hasHover={(item?.htd && true) || false}
                      // hasPersuasionTitlePadding={index === 0}
                      data={additionalPersuasion}
                      defaultIcon="tDiscount" // this binds it to HermesIconSelector
                      // direction="bottom-right"
                      position={{
                        wrapperDiv: {
                          bottom: '2rem',
                          left: '0',
                        },
                        tip: {
                          bottom: '-0.2rem',
                          left: '15%',
                          transform: 'translate(-50%, 50%) rotate(45deg)',
                        },
                      }}
                      type="contentPersuasion2" // for rectangular text box instead of border radius-ed
                      hasMainTextIcon
                      persuasionTitleStyles={{
                        border: buildMisc().borderRadius.base,
                        margin: `0 ${buildSpacing().small} 0 0`,
                      }}
                    />
                  </S.FBOFCADDealText>
                )}
              </S.FBOFCADContainer>
            )}
            {(showSignUpPersuasion && (
              <SignUpPersuasion
                onClick={() => {
                  detailsPageClickGaPush({
                    eventAction: DetailsGAClickEventActions.signUpPersuasionClick,
                    eventLabel: LoggedInPriceBenefitLabel,
                  });
                  toggleSiginPopupCaller();
                }}
                dealPrice={roomPriceAfterLogin}
                styledProps={{perRoomPerNightLabelTextTransform: 'none'}}
                showStartingFrom
              />
            )) ||
              (!isLoggedIn && (
                <ClientOnly>
                  <LoginPersuasionWithoutPrice
                    onClick={() => {
                      detailsPageClickGaPush({
                        eventAction: DetailsGAClickEventActions.signUpPersuasionClick,
                      });
                      toggleSiginPopupCaller();
                    }}
                  />
                </ClientOnly>
              )) ||
              null}
            {/* <EMIPersuasion emiStartingPrice={emiStartingPrice} emiRates={emiRates}/> */}
            <BookingWidget />
            {/* <Attractions /> */}
          </S.SignUpPersuasionEMIBookingWidgetContainer>
        </S.UGCPersuasionsAndBookingWidget>
      </S.Container>
    </OuterWrapperDiv>
  );
}

export default PriceNBookingButtonNPersuasion;
